/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=1b984438"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1b984438&lang=less"

import exportComponent from "/layers/paketo-buildpacks_npm-install/build-modules/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__